import React, { useEffect } from 'react';
import { CustomizeSpaceOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';

const CustomizeSpaceOnboarding = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = 'Mindspace: Customize Your Space';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Customize Space - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} />;
};

export default CustomizeSpaceOnboarding;
